<template>
  <div class="dogoodsPeopleWrapper">
  <div class="dogoodsPeopleTitle">
    <div class="dogoodsLine"></div>
    <div class="dogoodsText">他们赞了Ta</div>
    <div class="dogoodsLine"></div>
  </div>
  <div class="dogoodImgWrapper">
    <img :src="goodThumbs.avatarUrl!=null&&goodThumbs.avatarUrl!=''?goodThumbs.avatarUrl:globalUrl + 'images/basicprofile.png'" class='dogoodImg' v-for="goodThumbs in goodThumbs" />
  </div>
</div>
</div>
</template>
<script type = "text/ecamscript-6">
import {getDateDiff,config} from  '../../../common/js/common.js'
export default {
  name:"doGoodNum",
  props:['getThumbs','goodThumbs'],
  data(){
    return{
     paperThumbs:[],
     page:1,
     pageSize:10,
     globalUrl : config.gobalUrl
    }
  },
  created () {
    //this.login()
    this.getThumbs(0)
  },
  methods:{

  }
}

</script>
<style  lang="stylus">
  .dogoodsPeopleTitle
    margin-top:45px
    display:flex
    .dogoodsLine
      flex: 1
      border-top: 1px solid #e5e5e5
      /*px*/
      position: relative
      top: 12px
    .dogoodsText
      font-size: 24px
      line-height: 25px
      padding: 0 20px
      color: #666
  .dogoodImgWrapper
    margin-top: 30px
    .dogoodImg
      width: 58px
      height: 58px
      border-radius: 50%
      margin-left: 10px
</style>



// WEBPACK FOOTER //
// src/components/userCenter/mall/doGoodNum.vue